export class ServerError extends Error {
  constructor(statusCode, message) {
    super(`Error ${statusCode}: ${message}`);
    this.name = `Error ${statusCode}`;
    this.message = message;
  }
}
